/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountEphemeralCredentialsBase {
    type: string;

    protected setDiscriminator(type: string) {
        this.type = type;
    }

    getFixupPrototypeFunction() { return ServiceAccountEphemeralCredentialsBase.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountEphemeralCredentialsBase>): ServiceAccountEphemeralCredentialsBase {
        let obj = Object.assign(new ServiceAccountEphemeralCredentialsBase(), model);
        ServiceAccountEphemeralCredentialsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountEphemeralCredentialsBase>): ServiceAccountEphemeralCredentialsBase {
        if (!model) return null;
        return ServiceAccountEphemeralCredentialsBase.newInstance(<ServiceAccountEphemeralCredentialsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountEphemeralCredentialsBase) {
        if (!obj) return;

        models.ServiceAccountEphemeralCredentialsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountEphemeralCredentialsBase): boolean {
        switch (obj.type)
        {
            case "ServiceAccountEphemeralCredentialsBaseForAzure":
                Object.setPrototypeOf(obj, models.ServiceAccountEphemeralCredentialsBaseForAzure.prototype);
                break;
            case "ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol.prototype);
                break;
            case "ServiceAccountEphemeralCredentialsForAzureCsp":
                Object.setPrototypeOf(obj, models.ServiceAccountEphemeralCredentialsForAzureCsp.prototype);
                break;
            case "ServiceAccountEphemeralCredentialsForAzureManagedIdentity":
                Object.setPrototypeOf(obj, models.ServiceAccountEphemeralCredentialsForAzureManagedIdentity.prototype);
                break;
            case "ServiceAccountEphemeralCredentialsForGcpOauthProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountEphemeralCredentialsForGcpOauthProtocol.prototype);
                break;
            case "ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol.prototype);
                break;
            case "ServiceAccountEphemeralCredentialsForGitHubAppProtocol":
                Object.setPrototypeOf(obj, models.ServiceAccountEphemeralCredentialsForGitHubAppProtocol.prototype);
                break;
            case "ServiceAccountEphemeralCredentialsForVmware":
                Object.setPrototypeOf(obj, models.ServiceAccountEphemeralCredentialsForVmware.prototype);
                break;
            case "ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud":
                Object.setPrototypeOf(obj, models.ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof ServiceAccountEphemeralCredentialsBase)[] {
        return [
            models.ServiceAccountEphemeralCredentialsBaseForAzure,
            models.ServiceAccountEphemeralCredentialsForAwsAssumeRoleProtocol,
            models.ServiceAccountEphemeralCredentialsForAzureCsp,
            models.ServiceAccountEphemeralCredentialsForAzureManagedIdentity,
            models.ServiceAccountEphemeralCredentialsForGcpOauthProtocol,
            models.ServiceAccountEphemeralCredentialsForGcpServiceAccountProtocol,
            models.ServiceAccountEphemeralCredentialsForGitHubAppProtocol,
            models.ServiceAccountEphemeralCredentialsForVmware,
            models.ServiceAccountEphemeralCredentialsForZohoServiceDeskCloud,
        ];
    }

    fixupFields() {
        if (this.retry_after === undefined) {
            this.retry_after = 0;
        }
        if (typeof this.valid_until === "string") {
            this.valid_until = new Date(<string><any>this.valid_until);
        }
    }

    /**
     * Expiration Time of Credentials
     */
    valid_until: Date;

    /**
     * Invalid credentials
     */
    failure_reason: string;

    /**
     * Request submitted, in the queue. Retry after X seconds.
     */
    retry_after: number;

}
